import { useState, useCallback } from 'react';
import axios from 'axios';

function useMultipleFetchListen () {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const getUpdatedPayload=({source,bookType,payload})=>{
        let bookId = Readium.bookData.id
        // let spineId = bookType == "epub" ? _epubController.attributes.spineIdref:payload.textId.split("-")[1]
        let spineId = bookType == "epub" ? _epubController.getCurrentSpineId():payload.textId.split("-")[1]
        return{
            "bookId":bookId,
            "conversionType": "SENTENCE",
            "spineId": spineId||"DNC",
            "sourceLanguage": source ? (bookType == "epub" ? _epubController.attributes.language : 'en') : payload.targetLanguageCode,
            "targetLanguage": source ? (bookType == "epub" ? _epubController.attributes.language : 'en') : payload.targetLanguageCode,
            "text": source ? payload.string : payload.translatedText,
            "textId": bookType == "epub" ? source ? payload.id : (payload.textId !="DNC")?payload.textId + "_"+payload.targetLanguageCode:payload.textId : (payload.textId !="DNC")?payload.textId + "_"+payload.targetLanguageCode:payload.textId 
        }
    }
    const fetchData = useCallback(async ({source,bookType,selectedTextArray}) => {
        setLoading(true);
        setError(null);
        let url = Config.SERVICE_BASE_PATH + "/speakOut?timestamp=" + Date.now();
        let token = Readium.userInfo.accessToken;
        try {
            const responses = await Promise.all(
                selectedTextArray.map(payload => {
                    let data = getUpdatedPayload({source,bookType,payload})
                    return axios.post(url,data,{ 'accessToken': token, 'platform': 'WR', 'Content-Type': 'application/json' })
                })
            );
            const data = await Promise.all(
                responses.map(response => {
                    if (!response.status === 200) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    if( response.data.success===false)
                    {
                        throw new Error(`HTTP error! status: ${response.data.message}`);
                    }
                    return response.data;
                })
            );
            setData(data);
        } catch (err) {
            setError(err.message);
            setData([]);
        } finally {
            setLoading(false);
        }
    }, []);

    return { data, loading, error, fetchData };
};

export default useMultipleFetchListen;
